module.exports = __webpack_public_path__ + "static/media/genisis5.f6d21357.jpg";